// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2_hW9","content":"ManualTimeModal_content__3c8cQ"};